import { useToast } from '@/components/Toast'
import useWebviewBridge from '@/store/bridge'
import { useWebviewStore } from '@/store/webview'
import { useCallback } from 'react'

type Props = {
  title?: string
  description?: string | null
  image?: string
  url?: string
}

export const useShare = ({ title, description, image, url }: Props) => {
  const webview = useWebviewStore()
  const bridge = useWebviewBridge()
  const toast = useToast()

  const share = useCallback(() => {
    const __url = `${location.origin}${url || location.pathname}`
    const __title = title || 'VWORLD 버추얼월드'
    const __description = description || '버추얼 팬덤 커뮤니티로 놀러오세요!'

    if (webview.isNative) {
      bridge.share(__url, __title)
    } else {
      const data = { url: __url, title: __title, text: __description }
      if (navigator.userAgent.match(/Android|iPhone|iPad|iPod/i)) {
        if (navigator.share && navigator.canShare(data)) {
          navigator.share(data)
        } else {
          navigator.clipboard.writeText(__url)
          toast.push('링크가 복사되었습니다.')
        }
      } else {
        navigator.clipboard.writeText(__url)
        toast.push('링크가 복사되었습니다.')
      }
    }
  }, [webview.isNative, bridge, toast, title, description, url])

  return share
}
